import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
// axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET => ALL WORKSHOPS SERVICE
export const getWorkshopsService = createAsyncThunk(
  "workshops/getWorkshopsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.workshopsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST => CREATE WORKSHOP SERVICE
export const createWorkshopService = createAsyncThunk(
  "workshops/createWorkshopService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.workshopsURL, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE => DELETE WORKSHOP SERVICE
export const deleteWorkshopService = createAsyncThunk(
  "workshops/deleteWorkshopService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.workshopsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE => UPDATE WORKSHOP SERVICE
export const updateWorkshopService = createAsyncThunk(
  "workshops/updateWorkshopService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.workshopsURL}/${params?.id}`,
        params.formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET => GET WORKSHOP BY ID SERVICE
export const getWorkshopByIdService = createAsyncThunk(
  "workshops/getWorkshopByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.workshopsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET => ALL TAGS SERVICE
export const getTagsService = createAsyncThunk(
  "workshops/getTagsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.tagsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST => CREATE TAG SERVICE
export const createTagService = createAsyncThunk(
  "workshops/createTagService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.tagsURL, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE => DELETE TAG SERVICE
export const deleteTagService = createAsyncThunk(
  "workshops/deleteTagService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.tagsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE => UPDATE TAG SERVICE
export const updateTagService = createAsyncThunk(
  "workshops/updateTagService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.tagsURL}/${params?.id}`,
        params.formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET => GET TAG BY ID SERVICE
export const getTagByIdService = createAsyncThunk(
  "workshops/getTagByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.tagsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
